"use client";
import { Breadcrumbs, BreadcrumbsProps } from "@/components/shared/Breadcrumbs";
import st from "@/styles/modules/typography.module.scss";
import s from "./SectionPromo.module.scss";
import { PropsWithChildren, ReactNode } from "react";
import Image, { ImageProps } from "next/legacy/image";
import { Container } from "@/components/layout/Container";
import { Heading } from "@/components/UI/typography/Heading";
import cn from "classnames";

export type SectionPromoProps = PropsWithChildren<{
  breadcrumbs: BreadcrumbsProps;
  heading: ReactNode;
  subheading?:
    | ReactNode
    | {
        multiline: true;
        content: ReactNode;
      };
  image: ImageProps;
  list?: string[];
  buttons?: ReactNode;
  divider?: boolean;
  long?: boolean;
}>;

export const SectionPromo = ({
  breadcrumbs,
  image,
  heading,
  subheading,
  buttons,
  divider,
  list,
  long,
  children,
}: SectionPromoProps) => (
  <section
    className={cn(s.section, {
      [s.withDivider]: divider,
      [s.long]: long,
    })}
  >
    <Container className={s.container}>
      <Breadcrumbs {...breadcrumbs} className={s.breadcrumbs} />
      <div className={s.inner}>
        <div className={s.main}>
          <Heading level={1} className={s.heading}>
            {heading}
          </Heading>
          {!!subheading &&
            (typeof subheading === "object" && "multiline" in subheading ? (
              <div className={s.subheadingMultilined}>{subheading.content}</div>
            ) : (
              <p className={s.subheading}>{subheading}</p>
            ))}
          {list && (
            <ul className={cn(st.bigList, st.bigListVertical, s.list)}>
              {list.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          )}
          {buttons && <div className={s.btnsWrap}>{buttons}</div>}
        </div>
        <div className={s.imgWrap}>
          <Image {...image} priority />
        </div>
      </div>
      {children}
    </Container>
  </section>
);
